interface OrderableType {
  inventory: {
    orderable: boolean;
  };
}

export const isOrderable = ({ inventory }: OrderableType) => inventory && inventory.orderable;

export const getColor = (color: string) => {
  switch (color) {
    case 'Black':
      return '#000000';
    case 'Blue':
      return '#1A2252';
    case 'Bronze':
      return '#cd7f32';
    case 'Silver':
      return '#BEC2CB';
    default:
      return '#fff';
  }
};

export const productImagesMainSettings: any = {
  infinite: true,
  slidesToShow: 1,
  arrows: false,
  slidesToScroll: 1,
  draggable: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        dots: false,
      },
    },
  ],
};
